export default "__VITE_ASSET__CZpFJzxv__"